export const TOGGLE_DROPDOWN = 'TOGGLE_DROPDOWN';
export const SET_SEARCHED_TEXT = 'SET_SEARCHED_TEXT';
export const SET_DISPLAYED_OPTIONS = 'SET_DISPLAYED_OPTIONS';
export const SET_SELECTED_OPTION = 'SET_SELECTED_OPTION';
